import { render, staticRenderFns } from "./CallCentreCases.vue?vue&type=template&id=03d2997b"
import script from "./CallCentreCases.vue?vue&type=script&setup=true&lang=js"
export * from "./CallCentreCases.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports